module.exports = __webpack_public_path__ + "img/cramera_des_1.173f587b.jpg";